var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:("svg-icon icon-" + _vm.src + " " + _vm.css)},[_c('use',_vm._b({},'use',{ 'xlink:href': (_vm.symbolDefs + "#icon-" + _vm.src) },false))])}
var staticRenderFns = []

export { render, staticRenderFns }